export const ZHHANS = {
  "Open document": "æå¼ææ¡£",
  "Upload file": "ä¸ä¼ æä»¶",
  "Drop file here to upload": "å°æä»¶ææ¾å°æ­¤å¤ä»¥ä¸ä¼ ",
  "Disc": "åç",
  "URL": "ç½å",
  "FILE": "æä»¶",
  "SIZE": "å°ºå¯¸",
  "MB": "MB",
  "KB": "ç¥è¯åº",
  "Bytes": "å­è",
  "Loading... Please wait.": "å è½½è¯·ç¨åã",
  "Fit Width": "éåå®½åº¦",
  "Fit Height": "éåé«åº¦",
  "Password protected document": "åå¯ç ä¿æ¤çæä»¶",
  "Password": "å¯ç ",
  "Open": "æå¼",
  "Password Required": "éè¦å¯ç ",
  "Incorrect password": "å¯ç éè¯¯",
  "Error": "éè¯¯",
  "Something went wrong": "åºäºäºé®é¢",
  "Server is not available": "æå¡å¨ä¸å¯ç¨",
  "of": "ç",
  "Please wait...": "è¯·ç¨ç­..."
};
